/* sticky add-cart
function updateProductDetailsClass() {
  const productDetails = document.querySelector('.product-information__grid');
  if (!productDetails) return;

  if (window.innerWidth < 1023) {
    if (!productDetails.classList.contains('mobile-view')) {
      productDetails.classList.add('mobile-view');
    }
    
    const wrapper = productDetails.querySelector('.mobile-view-wrapper');
    if (wrapper && !wrapper.hasClickListener) {
      wrapper.addEventListener('click', () => {
        productDetails.classList.toggle('mobile-view-expanded');
      });
      wrapper.hasClickListener = true;
    }

    const groupContent = productDetails.querySelector('.group-block-content');
    if (groupContent) {
      const firstGroupBlock = groupContent.querySelector('.group-block');
      if (firstGroupBlock && !firstGroupBlock.hasClickListener) {
        firstGroupBlock.addEventListener('click', () => {
          productDetails.classList.toggle('mobile-view-expanded');
        });
        firstGroupBlock.hasClickListener = true;
      }
    }

    // Add scroll listener only once
    if (!window.hasProductScrollListener) {
      window.addEventListener('scroll', (event) => {
        const productDetails = document.querySelector('.product-information__grid');
        if (!productDetails) return;

        // Check if the user is actively interacting inside .product-details
        const isScrollingInsideProductDetails = productDetails.contains(document.activeElement);

        // OR — better: check if the mouse/pointer is over the element
        const isHovering = productDetails.matches(':hover');

        if (
          productDetails.classList.contains('mobile-view-expanded') &&
          !isScrollingInsideProductDetails &&
          !isHovering
        ) {
          productDetails.classList.remove('mobile-view-expanded');
        }
      }, { passive: true });

      window.hasProductScrollListener = true;
    }
    
  } else {
    if (productDetails.classList.contains('mobile-view')) {
      productDetails.classList.remove('mobile-view');
      productDetails.classList.remove('mobile-view-expanded');
    }
  }
}

  function setupAddToCartButton() {
    const addToCartBtn = document.querySelector('.drag-handle');
    if (!addToCartBtn) return;

    addToCartBtn.addEventListener('click', (e) => {
      e.preventDefault();

      const productDetails = document.querySelector('.product-information__grid');
      if (!productDetails) return;

      if (!productDetails.classList.contains('mobile-view-expanded')) {
        productDetails.classList.add('mobile-view-expanded');
      } else {
        productDetails.classList.remove('mobile-view-expanded');
      }
    });
  }

  function setupWindowScrollToggle() {
    const productDetails = document.querySelector('.product-information__grid.mobile-view');
    const recommendations = document.querySelector('.product-recommendations');

    if (!productDetails || !recommendations) return;

    let lastScrollY = window.scrollY || window.pageYOffset;

    // Get the absolute top position of recommendations relative to the document
    const recommendationsTopAbs = recommendations.getBoundingClientRect().top + window.scrollY;

    window.addEventListener('scroll', () => {
      const scrollY = window.scrollY || window.pageYOffset;
      const viewportHeight = window.innerHeight;
      const scrollDirectionDown = scrollY > lastScrollY;
      lastScrollY = scrollY;

      // Position of the bottom of the viewport relative to the document
      const viewportBottom = scrollY + viewportHeight;

      // Debug logs (remove later)
      // console.log('scrollY:', scrollY);
      // console.log('viewportBottom:', viewportBottom);
      // console.log('recommendationsTopAbs:', recommendationsTopAbs);
      // console.log('scrollDirectionDown:', scrollDirectionDown);

      if (scrollDirectionDown && viewportBottom >= recommendationsTopAbs) {
        // User scrolled down and reached (or passed) the recommendations section
        productDetails.classList.remove('mobile-view');
        // console.log('Removed mobile-view');
      } else if (!scrollDirectionDown && viewportBottom < recommendationsTopAbs) {
        // User scrolled up and hasn't reached recommendations yet
        if (!productDetails.classList.contains('mobile-view')) {
          productDetails.classList.add('mobile-view');
          // console.log('Added mobile-view');
        }
      }
    });
  }


  function init() {
    updateProductDetailsClass();
    setupAddToCartButton();

    const productDetails = document.querySelector('.product-information__grid.mobile-view');
    if (productDetails) {
      setupWindowScrollToggle();
    }
  }
  init();
  window.addEventListener('resize', () => {
    updateProductDetailsClass();
    init();
  });
*/  

// image indicator / bullets
document.addEventListener('DOMContentLoaded', () => {
    const mediaItems = document.querySelectorAll('.product-media-container');
    const bullets = document.querySelectorAll('.scroll-indicator-bullets .bullet');
    const bulletContainer = document.querySelector('.scroll-indicator-bullets');
    const lastItem = mediaItems[mediaItems.length - 1];

    const highlightObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = entry.target.getAttribute('data-index');
            bullets.forEach((bullet, i) => {
              bullet.classList.toggle('active', parseInt(index) === i);
            });
          }
        });
      },
      {
        threshold: 0.6
      }
    );

    mediaItems.forEach((item) => highlightObserver.observe(item));

    // Observer for hiding bullets when last item is fully in view
    const hideObserver = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          bulletContainer.classList.add('hidden');
        } else {
          bulletContainer.classList.remove('hidden');
        }
      },
      {
        threshold: 1.0
      }
    );

    if (lastItem) hideObserver.observe(lastItem);

    // Optional: Click bullet to scroll
    bullets.forEach((bullet, i) => {
      bullet.addEventListener('click', () => {
        const target = document.querySelector(`.product-media-container[data-index="${i}"]`);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    });
});

// hide selected variant on load
const radios = document.querySelectorAll('.variant-option input[type="radio"]');
radios.forEach(radio => {
  radio.checked = false;
});

// on-load default button text
// on-load default button text
document.addEventListener('DOMContentLoaded', function () {
  const addToCartButton = document.querySelector('.add-to-cart-button');
  const addToCartText = addToCartButton?.querySelector('.add-to-cart-text__content');
  const productType = addToCartButton?.getAttribute('data-product-type');

  const setDefault = () => {
    if (!addToCartText) return;

    if (productType === 'Donation' || productType === 'Giftcard') {
      addToCartText.textContent = 'Select Value';
    } else {
      addToCartText.textContent = 'Select size';
    }
    addToCartButton.disabled = true;
  };

  const updateOnVariantSelection = () => {
    if (addToCartText) {
      addToCartText.textContent = 'Add to Bag';
      addToCartButton.disabled = false;
    }
  };

  const checkURLForVariant = () => {
    const url = new URL(window.location.href);
    const hasVariant = url.searchParams.has('variant');

    // If NO variant in URL → reset button to default state
    if (!hasVariant) {
      setDefault();
    }
  };

  // --- INITIAL LOAD ---
  setDefault();
  checkURLForVariant();

  // --- LISTEN FOR VARIANT SELECTION ---
  radios.forEach(radio => {
    radio.addEventListener('change', updateOnVariantSelection);
  });

  // --- LISTEN FOR URL CHANGES (Back button, theme JS, etc.) ---
  window.addEventListener('popstate', checkURLForVariant);

  // Optional: listen for theme JS pushing state
  const originalPushState = history.pushState;
  history.pushState = function () {
    originalPushState.apply(this, arguments);
    checkURLForVariant();
  };

  const originalReplaceState = history.replaceState;
  history.replaceState = function () {
    originalReplaceState.apply(this, arguments);
    checkURLForVariant();
  };
});




